import { ShoppingBasket, ShoppingCart, Tags, Pill, Newspaper, Store } from "lucide-react";

// Métadonnées services Personal Shopper — parité avec l'app mobile (SERVICE_META).
export const SERVICE_META = {
  MIGROS: { Icon: ShoppingBasket, accent: "#F60002", label: "Migros" },
  COOP: { Icon: ShoppingCart, accent: "#EA5B0C", label: "Coop" },
  ALDI: { Icon: Tags, accent: "#1E4B9B", label: "Aldi" },
  PHARMACY: { Icon: Pill, accent: "#0E9F6E", label: "Pharmacie" },
  KIOSK: { Icon: Newspaper, accent: "#7C3AED", label: "Kiosque" },
};

export const metaFor = (stopType, fallbackLabel) =>
  SERVICE_META[stopType] || { Icon: Store, accent: "#16a34a", label: fallbackLabel || stopType };
